import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/auth/services/auth.service';
import { ToastOverlayComponent } from './shared/components/toast-overlay/toast-overlay.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastOverlayComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private readonly authService = inject(AuthService);

  constructor() {
    queueMicrotask(() => {
      const splash = document.getElementById('app-startup-splash');

      if (!splash) {
        return;
      }

      splash.classList.add('is-hidden');

      window.setTimeout(() => {
        splash.remove();
      }, 200);
    });
  }
}